import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiResponseModel, ApiVisa, Pagination, PagingResponseModel } from "../shared";
import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { Core2Config } from "../shared/core2Config";
import { FilesDetailsRequest } from '../../../../../models/file-image';

@Injectable({ providedIn: "root" })
export class WmsItemImageService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "/wms/item-image-hdr";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms/item-image-hdr";
    this.httpClient = http;
  }

  getImageHdrItemFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/image-file/backoffice-ep/" + imageHdrGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  replaceImageHdrFile(formData: FormData, extGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-file/backoffice-ep/' + extGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  addImageHdrFile(files: File[], hdrGuid: string, visa: ApiVisa, filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl + '/add-images/backoffice-ep/' + hdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  deleteImageHdrFile(imageHdrGuid: string, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/backoffice-ep/' + imageHdrGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  get(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/backoffice-ep';
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getImagesByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
